module.exports = __webpack_public_path__ + "static/media/vmLockerStandAlone.a271a65a.png";